import createRoute from '@widesk-ui/tools/createRoute';
import MenuModel   from '@models/website/MenuModel';

const route = createRoute.splitView(
	`/website_entertainments/:websiteEntertainmentId/menus/mode/:mode`,
	'website',
	'MenuSplitView',
	MenuModel.localize('plural'),
);
export default route;
